import { useEffect, useRef } from 'react'
import { CHAMELEON_TOKEN, CHAMELEON_ENABLED } from '../config'

/**
 * Hook to initialize Chameleon.io and identify the current user.
 *
 * @param {Object} currentUser - The current user object
 * @param {string|number} currentUser.id - User ID
 * @param {string} currentUser.email - User email
 * @param {string} currentUser.name - User name
 * @param {string} chameleonHash - HMAC-SHA256 hash for secure user verification
 */
export function useChameleon(currentUser, chameleonHash) {
  const initializedRef = useRef(false)

  useEffect(() => {
    // Skip if already initialized, disabled, or no user
    if (initializedRef.current || !CHAMELEON_TOKEN || !CHAMELEON_ENABLED || !currentUser) {
      return
    }

    // Initialize Chameleon SDK
    ;(function(d, w) {
      var t = CHAMELEON_TOKEN,
        c = 'chmln',
        i = d.createElement('script')
      if ((w[c] || (w[c] = {}), !w[c].root)) {
        w[c].accountToken = t
        w[c].location = w.location.href.toString()
        w[c].now = new Date()
        w[c].fastUrl = 'https://fast.chameleon.io/'
        var m = 'identify alias track clear set show on off custom help _data'.split(' ')
        for (var s = 0; s < m.length; s++) {
          ;(function() {
            var methodQueue = (w[c][m[s] + '_a'] = [])
            w[c][m[s]] = function() {
              methodQueue.push(arguments)
            }
          })()
        }
        i.src = w[c].fastUrl + 'messo/' + t + '/messo.min.js'
        i.async = true
        d.head.appendChild(i)
      }
    })(document, window)

    // Identify user with Chameleon
    window.chmln.identify(currentUser.id, {
      uid_hash: chameleonHash,
      email: currentUser.email,
      name: currentUser.name,
    })

    initializedRef.current = true
  }, [currentUser, chameleonHash])
}

export default useChameleon
